module.exports = __webpack_public_path__ + "img/logo-with-app-title.9cf4dba5.svg";